<template>
  <div>
    <DolphinSelector v-model="model" :options="effectOptions" />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { AuthzPolicyEffectValues, AuthzPolicyEffectText } from '../types'
import DolphinSelector from '@/components/atoms/DolphinSelector.vue'

export type AuthzPolicyEffectForm = 'PERMIT' | 'FORBID'

const model = defineModel<AuthzPolicyEffectForm>({ required: true })

const effectOptions = computed(() =>
  AuthzPolicyEffectValues.map(value => ({
    value,
    text: AuthzPolicyEffectText[value],
  }))
)
</script>
